import type { SessionData } from '@optionway/models';

export const useSessionData = () => {
  const { locale } = useI18n();
  return computed(() => {
    const sessionData: SessionData = {
      language: locale.value,
      partnerId: usePartnerId().value,
      sessionId: useSearchSession().value,
      // The caller context reads the visitor's user agent where each side has it: the incoming request
      // headers during SSR (a request event only exists there), the browser's navigator afterwards.
      userAgent: useRequestEvent() ? useRequestHeaders(['user-agent'])['user-agent'] : navigator.userAgent,
    };
    return sessionData;
  });
};
